import { render } from "./indexUserForImobi.vue?vue&type=template&id=fbc704f4"
import script from "./indexUserForImobi.vue?vue&type=script&lang=js"
export * from "./indexUserForImobi.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__